function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 13 20" {...props}><path d="M6.164.358C2.887.358.231 3.056.231 6.384c0 6.026 5.933 13.258 5.933 13.258s5.933-7.232 5.933-13.258c0-3.328-2.656-6.026-5.933-6.026zm0 9.642c-1.966 0-3.56-1.619-3.56-3.616S4.198 2.77 6.164 2.77s3.56 1.618 3.56 3.615S8.13 10 6.164 10z" /></svg>;
});